export default __webpack_public_path__ + "static/media/logo-title.3b25a64e.svg";